module.exports = __webpack_public_path__ + "static/img/sg430.727582d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/sg430.jpg
// module id = uVbi
// module chunks = 0